import { any, node } from 'prop-types'
import {Stack} from "@bedrock-layout/stack";
import React from "react";

function Section({children, ...rest}){
  return(
      <Stack gutter="lgXl" {...rest}>
        {children}
      </Stack>
  )
}

Section.propTypes = {
  children: node.isRequired,
  rest: any
}

export default Section
